// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"210":"campaigns-list","487":"coderules-list","594":"subcampaigns-list","603":"codes-list"}[chunkId] || chunkId) + ".js";
};